<template>
  <component :is="component" />
</template>

<script>


import yuanLinKongZhiQi23Program from "./yuanLinKongZhiQi23/program.vue"
// import yuanLinKongZhiQi24Group from "./yuanLinKongZhiQi24/group.vue"

export default {

  components: { yuanLinKongZhiQi23Program },
  props: ['type'],
  data () {
    return {
      component: yuanLinKongZhiQi23Program
    }
  },

  // mounted () {
  //   this.renderComponent()
  // },

  // methods: {
  //   renderComponent () {
  //     console.log("园林控制器类的轮灌组 根据type挂载不同的组件  group");
  //     if (this.type == 23) {
  //       this.component = yuanLinKongZhiQi23Group
  //     } else {
  //       this.component = yuanLinKongZhiQi24Group
  //     }
  //   }
  // }
}
</script>

<style></style>
